import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const ImgMediaCard = ({ image, name, description }) => {
  return (
    <Card
      sx={{
        maxWidth: 345,
        backgroundColor: 'beige',
        border: '2px solid black',
      }}
    >
      <CardMedia
        component="img"
        alt={name}
        height="210"
        image={image}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {name}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{
            color: 'text.secondary',
            display: '-webkit-box',
            WebkitLineClamp: 3, // Limit text to 3 lines
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis', // Add ellipsis when text overflows
          }}
        >
          {description}
        </Typography>
      </CardContent>
      <CardActions>
        {/* <Button size="small">Chi tiết</Button>
        <Button size="small">Liên Hệ</Button> */}
      </CardActions>
    </Card>
  );
};

export default ImgMediaCard;
